import { createStyles, makeStyles } from "@material-ui/core/styles";


export default makeStyles((theme) => createStyles({
    item: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        borderBottom: `1px solid ${theme.palette.grey["300"]}`,
        boxSizing: "border-box",
        color: theme.palette.grey["700"],
        "&:hover": {
            backgroundColor: theme.palette.grey["100"],
            cursor: "pointer",
        },
        textDecoration: "none",
    },
    fullHeight: {
        height: 194,
    },
    clips: {
        display: "flex",
        flexDirection: "row",
    },
    clip: {
        height: 154,
        width: 205,
        margin: "0 2px",
        borderRadius: 4,
        position: "relative",
    },
    clipThumbnail: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        borderRadius: 4,
    },
    clipVideo: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        objectFit: "fill",
        borderRadius: 4,
    },
    hidden: {
        display: "none",
    },
    description: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "space-between",
        flexGrow: 1,
        padding: "0 40px",
    },
    descriptionHeader: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    leader: {
        height: 0,
        borderBottomStyle: "dashed",
        borderBottomWidth: 2,
        borderColor: theme.palette.grey["400"],
        flexGrow: 1,
        minWidth: 100,
    },
    headerText: {
        fontWeight: "bold",
    },
    leftHeader: {
        marginRight: "1em",
        textAlign: "start",
        maxWidth: "23em",
        minWidth: 180,
        display: "flex",
        alignItems: "center",
        height: 50,
    },
    rightHeader: {
        display: "flex",
        alignItems: "center",
        height: 50,
        marginLeft: "1em",
        textAlign: "end",
    },
    innerDescription: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginTop: 20,
    },
    itemButtons: {
        display: "flex",
        justifyContent: "flex-end",
        flexGrow: 1,
    },
    link: {
        textDecoration: "none",
    },
    viewer: {
        display: "flex",
        alignItems: "center",
        flexGrow: 1,
    },
    viewerText: {
        display: "flex",
        alignItems: "center",
        color: theme.palette.common.white,
        backgroundColor: theme.palette.error.main,
        padding: "0 8px",
        borderRadius: 4,
    },
    viewerIcon: {
        marginRight: "8px",
    },
    rightDivider: {
        borderRightStyle: "solid",
        borderRightWidth: 1,
        borderColor: theme.palette.grey["300"],
    },
    leftSection: {
        display: "flex",
        width: 623,
    },
    collapsedTimestamp: {
        flexShrink: 1,
        marginRight: 40,
    },
    resolveButton: {
        fontWeight: "bold",
    },
}));
